import React, { useCallback, useEffect, useState } from 'react';
import SpeechStudio from './labs/SpeechStudio';
import FrameSight from './labs/FrameSight';

export default function AudioVideoHub({ onBack, isAuthenticated, workspaceRestore, onWorkspaceRestored }) {
  const [mode, setMode]             = useState('speech');
  const [speechSeed, setSpeechSeed] = useState(1);
  const [videoSeed,  setVideoSeed]  = useState(1);

  const resetSpeech = useCallback(() => { setMode('speech'); setSpeechSeed(s => s + 1); }, []);
  const resetVideo  = useCallback(() => { setMode('video');  setVideoSeed(s => s + 1);  }, []);

  useEffect(() => {
    window.addEventListener('dd:speech_studio:new', resetSpeech);
    window.addEventListener('dd:video_intelligence:new', resetVideo);
    return () => {
      window.removeEventListener('dd:speech_studio:new', resetSpeech);
      window.removeEventListener('dd:video_intelligence:new', resetVideo);
    };
  }, [resetSpeech, resetVideo]);

  useEffect(() => {
    if (!workspaceRestore) return;
    if (workspaceRestore.module === 'speech_studio')      setMode('speech');
    if (workspaceRestore.module === 'video_intelligence') setMode('video');
  }, [workspaceRestore]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      {/* Both children always mounted so their internal state survives mode switch.
          The MODE selector lives inside each child's Upload tab, exactly like PixelMind. */}
      <div style={{ display: mode === 'speech' ? 'block' : 'none', minHeight: 0 }}>
        <SpeechStudio key={speechSeed} experiment={{}} onUpdate={() => {}}
          avMode={mode} onAvModeChange={setMode} isAuthenticated={isAuthenticated} />
      </div>
      <div style={{ display: mode === 'video' ? 'block' : 'none', minHeight: 0 }}>
        <FrameSight key={videoSeed} experiment={{}} onUpdate={() => {}}
          avMode={mode} onAvModeChange={setMode} isAuthenticated={isAuthenticated} />
      </div>
    </div>
  );
}
